/**
 * @name hasOneliner
 * @param {String} oneLiner - seller's oneliner text
 * @return {Boolean} Does this seller have a valid oneliner text?
 */
export function hasOneliner(oneLiner) {
    return oneLiner && oneLiner.length > 0 && oneLiner !== i18n.t('seller_card.oneliner.placeholder');
}

/**
 * @name showResponseTime
 * @param {String} sellerResponsiveness - seller's responsive time
 * @return {Boolean} Does this seller have a valid responsive time?
 */
export function showResponseTime(sellerResponsiveness) {
    return parseInt(sellerResponsiveness, 10) > 0;
}

/**
 * @name formatHoursAsDays
 * @param {Integer} hours - the hours that should be formatted
 * @return {String} A translated string with either hours or days
 */
export function formatHoursAsDays(hours) {

    let output;

    if (hours < 24) {
        output = i18n.t('seller_card.response_time_hours', {count: hours});
    } else {
        const days = Math.round(hours / 24);
        output = i18n.t('seller_card.response_time_days', {count: days});
    }

    return output;
}

/**
 * Replace break tags with something else
 * @param  {String} string
 * @param  {String} [replacer='\r\n']
 * @return {String}
 */
export const replaceBreakTags = (string, replacer = '\r\n') => string.replace(/\s?(<br\s?\/?>)\s?/g, replacer); // eslint-disable-line no-control-regex



// WEBPACK FOOTER //
// ./src/utils.js